var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGnosis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 600 600",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 600,
    rx: 300,
    fill: "#04795B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M218.49 327.17c11.815 0 22.722-3.937 31.508-10.751l-72.106-72.08c-6.817 8.631-10.755 19.534-10.755 31.497-.152 28.317 22.874 51.334 51.353 51.334zm214.5-51.48c0-11.811-3.938-22.714-10.755-31.497l-72.106 72.08c8.634 6.814 19.541 10.751 31.508 10.751 28.328.152 51.353-22.865 51.353-51.334z",
    fill: "#EFEFEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m469.35 197.4-31.963 31.951c10.604 12.72 16.966 28.772 16.966 46.64 0 40.128-32.569 72.685-72.712 72.685-17.723 0-33.932-6.36-46.657-16.96l-34.992 34.98-34.993-34.98c-12.724 10.6-28.782 16.96-46.657 16.96-40.143 0-72.711-32.557-72.711-72.685 0-17.717 6.362-33.92 16.966-46.64l-16.361-16.354-15.602-15.597c-18.178 29.983-28.63 64.963-28.63 102.52 0 109.33 88.617 197.76 197.84 197.76 109.22 0 197.84-88.585 197.84-197.76.303-37.706-10.149-72.686-28.327-102.52z",
    fill: "#EFEFEF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M443.14 163.33c-35.901-37.705-86.8-61.328-143.15-61.328-56.352 0-107.1 23.623-143.15 61.328a237.919 237.919 0 0 0-13.936 16.203l156.94 156.88 156.94-157.03c-3.939-5.452-8.635-11.055-13.634-16.052zm-143.15-35.585c46.354 0 89.375 17.868 121.64 50.425l-121.64 121.6-121.64-121.6c32.417-32.557 75.287-50.425 121.64-50.425z",
    fill: "#EFEFEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGnosis);
export default __webpack_public_path__ + "static/media/gnosis.605e6d9ef6a04502aa902333cc70d356.svg";
export { ForwardRef as ReactComponent };